<div class="ai-token-modal token-restock-container">
  <div class="logo-container mt-2">
    <img src="assets/images/brand/worldtumbler-on-dark.svg" alt="WorldTumbler" class="main-logo" width="200">
  </div>

  <h2 class="modal-title mt-3">You've reached your available token limit.</h2>

  <p class="description text-center">
    Add more tokens to keep creating lore, and images without interruption.
  </p>

  <div class="purchase-section mt-4 w-100">
    <h3 class="text-center text-white fw-bold mb-3 purchase-title text-uppercase">Purchase</h3>

    @if (isLoading) {
      <div class="d-flex justify-content-center align-items-center w-100" style="min-height: 100px;">
        <div class="spinner-border text-light" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    }

    @if (!isLoading) {
      <div class="cards-container">
        @for (product of tokenPacks; track product) {
          <div class="purchase-card" (click)="buyProduct(product.id)">
            <div class="card-inner">
              <h5 class="fw-bold">{{product.name}}</h5>
              <p class="small mb-0">{{product.description.length > 50 ? (product.description | slice:0:50) + '...' :
              product.description}}</p>
            </div>
            <div class="price-tag fw-bold">${{product.price}}</div>
          </div>
        }
      </div>
    }
  </div>

  <div class="action-btn text-center mt-4">
    <button type="button" class="btn btn-dark" (click)="closeModal()">Back</button>
  </div>

  <div class="footer-note text-center mt-3 mb-2">
    <p class="small fw-light mb-0" style="font-size: 10px;">*Purchase tokens are used after monthly subscription tokens,
    Purchased Tokens do not expire and are not transferable.</p>
  </div>
</div>
